import(/* webpackMode: "eager", webpackExports: ["BookNow"] */ "/usr/src/app/apps/dottingen/components/book-now/BookNow.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/dottingen/components/gallery-slider/GallerySlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroImage"] */ "/usr/src/app/apps/dottingen/components/hero/HeroImage.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/dottingen/components/hero/HeroMain.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/dottingen/components/list-items/ListItems.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/dottingen/components/pre-intro/PreIntro.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/dottingen/components/room-grid/RoomShowcase.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/dottingen/components/slider-items/SliderItems.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/usr/src/app/apps/dottingen/lib/i18n-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/usr/src/app/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
